import { memo } from 'react'

import { Body2, Stack, Tooltip } from '@collaborate-health/uikit'
import { useSelector } from '@tabeeb/store'
import {
  getCanRenameContentDescriptionForTenant,
  getContentDescriptionForTenant,
} from '@tabeeb/modules/sessionsPage/selectors/contentSharings'
import { ContentReviewRequest, ContentSharingType } from '@tabeeb/contracts/main-api/swagger-main-api'
import RenameButton from './RenameButton'

interface SharedForReviewContentProps {
  review: ContentReviewRequest
}

const SharedForReviewContent: React.FC<SharedForReviewContentProps> = ({ review }) => {
  const tenantId = review?.ReviewerTenantId
  let isRenameButtonVisible = useSelector((state) => getCanRenameContentDescriptionForTenant(state, { tenantId }))
  let description = useSelector((state) => getContentDescriptionForTenant(state, { tenantId }))
  const isMergeReview = review?.Type === ContentSharingType.MergeForReview

  if (!tenantId) {
    return null
  }

  isRenameButtonVisible = isRenameButtonVisible && !isMergeReview
  description = isMergeReview ? review.TargetContentName : description

  return (
    <Stack direction='row' alignItems='center' spacing={1}>
      <Tooltip text={description}>
        <Body2 noWrap>Content Name: {description}</Body2>
      </Tooltip>

      {isRenameButtonVisible && <RenameButton tenantId={tenantId} />}
    </Stack>
  )
}

export default memo(SharedForReviewContent)

